import { FormStatusTokens } from 'styles/formStatusTokens';

import { FormStatus } from './entity';
import { STATUS_TEXTS } from './texts';

export type StatusMapperValue = {
  colorToken: FormStatusTokens;
  label: string;
};

export const STATUS_MAPPER: Record<FormStatus, StatusMapperValue> = {
  [FormStatus.DRAFT]: {
    label: STATUS_TEXTS[FormStatus.DRAFT],
    colorToken: FormStatusTokens.first,
  },
  [FormStatus.FILE_UPLOAD]: {
    label: STATUS_TEXTS[FormStatus.FILE_UPLOAD],
    colorToken: FormStatusTokens.first,
  },
  [FormStatus.VALIDATION]: {
    label: STATUS_TEXTS[FormStatus.VALIDATION],
    colorToken: FormStatusTokens.first,
  },
  [FormStatus.PUBLISHED]: {
    label: STATUS_TEXTS[FormStatus.PUBLISHED],
    colorToken: FormStatusTokens.second,
  },
  [FormStatus.FINISHED]: {
    label: STATUS_TEXTS[FormStatus.FINISHED],
    colorToken: FormStatusTokens.third,
  },
};
